import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentTextIcon } from '@heroicons/react/24/outline';

import type { CommunitySearchComment } from '~/interfaces/community';

export const CommentResultRow: FC<{ comment: CommunitySearchComment }> = ({ comment }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 py-4 pr-4 pl-2 hover:bg-black/5 transition-colors">
      <div className="flex items-center justify-center size-8 shrink-0">
        <DocumentTextIcon className="size-4 text-black/50" />
      </div>
      <div className="flex flex-col gap-1 min-w-0 flex-1">
        <span className="truncate text-[15px] leading-5 font-semibold tracking-[-0.01em] text-black">
          {comment.content}
        </span>
        <span className="truncate text-[13px] leading-4 tracking-[-0.01em] text-black/70">
          {t('community.search.comment_in_post', {
            title: comment.post.title,
            interpolation: { escapeValue: false },
          })}
        </span>
      </div>
    </div>
  );
};
